import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { getCardCheckerCard } from '../../areas/cards/selectors';

const Requirements = {
    SpotCheck: 'spotCheck',
    Swipes: 'swipes',
    None: 'none'
};

function PrivRoute(props) {
    const { cardChecker, requirements, component: Component, ...rest } = props;

    let canAccess = props.loggedIn || requirements === Requirements.None;
    let redirectTo = "/login";

    if (cardChecker && canAccess && requirements !== Requirements.None) {
        if (requirements === Requirements.SpotCheck) {
            canAccess = cardChecker.canPerformSpotCheck;
        } else if (requirements === Requirements.Swipes) {
            canAccess = cardChecker.canSwipeCards;
        }

        if (!canAccess && props.alt) {
            redirectTo = props.alt;
        }
    }

    return (
        <Route {...rest} component={() =>
            canAccess
                ? <Component {...rest} />
                : <Redirect to={redirectTo} />
        } />
    );
}

PrivRoute.propTypes = {
    component: PropTypes.object,
    requirements: PropTypes.oneOf([
        Requirements.None,
        Requirements.Swipes,
        Requirements.SpotCheck
    ])

};

function mapStateToProps(state) {
    const { auth } = state;
    const processedCardCheckerCard = getCardCheckerCard(state);
    return {
        loggedIn: auth.loggedIn,
        cardChecker: processedCardCheckerCard
    }
}

export default connect(mapStateToProps)(PrivRoute);